import React, {useEffect, useState} from "react";
import {Button, Layout, List} from "antd";
import SideBar from "../Navbars/SideBar";
import NavBar from "../Navbars/NavBar";
import {
    MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBBtn, MDBNav, MDBNavItem, MDBNavLink,
    MDBContainer, MDBRow, MDBBox, MDBNavbarNav, MDBNavbar, MDBIcon, MDBCol
} from "mdbreact";
import holder from "../../holder.jpg";
import { useAuthState } from 'react-firebase-hooks/auth';
import Firebase from "../../Firebase";
import ChangePassword from "../Modals/Settings/ChangePassword";
import ChangeEmail from "../Modals/Settings/ChangeEmail";
import {Dialog} from "evergreen-ui";


const { Content } = Layout;

var moment = require("moment");
const data = [
    {
        title: 'Fullname:  John Doe',
    },
    {
        title: 'Email: john@somewhere.com',
    },
    {
        title: 'Number: 12343445',
    },
    {
        title: 'Location : Chimwankhunda',
    },
];

var userRef = Firebase.database().ref("System/Users");
const Settings = () => {

    const [user, loading, error] = useAuthState(Firebase.auth());
    const [details, setDetails] = useState();
    const [checkedData, setCheckedData] = useState(true);
    const [modal, setModal] = React.useState(false);
    const [modal2, setModal2] = React.useState(false);

    const toggleModal = () => {
        setModal(!modal);
    }
    const toggleModal2 = () => {
        setModal2(!modal2);
    }
    const callback = (data) => {
        setCheckedData(data);
    }

    
    useEffect(() => {
        if(user){
            console.log(user);
            userRef.child(user.uid).on("value", function (snapshot) {
                var userDet = snapshot.val();
                console.log(userDet);
                setDetails(userDet);
            });
        }
    }, [user]);

    return (
        <Layout style={{width: "100vw"}}>
            <SideBar checked={checkedData}/>
            <Layout className="site-layout">
                <NavBar token={"token"} checkBack={callback}/>
                <Content
                    className="site-layout-background"
                    style={{ margin: '10px 16px 15px'}}
                >

                    <MDBBox>

                        <div className="mb-3 ml-3">
                            <MDBRow className="align-items-center">
                                <h4 className="ml-1 float-left flex-row">Settings</h4>
                            </MDBRow>

                            <MDBRow className="mr-1 mt-2">
                                <div style={{width:"100%", height:"10rem"}} className="d-flex flex-row align-items-center bg">
                                    <div className="d-flex flex-row ml-3 div2">
                                        <img src={holder} style={{width: "6rem", height: "6rem"}} className="rounded img-thumbnail float-left d-inline" alt="aligment" />
                                        <div className="d-inline mx-3 mt-4 text-white white-text">
                                            <p className="white-text h4 font-weight-bold">{details&&details.firstname}  {details&&details.surname}</p>
                                            <b className="font-italic h6">Admin</b>
                                        </div>
                                    </div>
                                </div>

                            </MDBRow>
                        </div>

                        <MDBCard className="mt-4">
                            <MDBCardHeader>
                                <MDBNav className="nav-tabs">
                                    <MDBNavItem>
                                        <MDBNavLink active to="#!">Personal Info</MDBNavLink>
                                    </MDBNavItem>
                                </MDBNav>
                            </MDBCardHeader>
                            <MDBCardBody>
                                <MDBCardTitle>

                                    <MDBRow className="mb-3 d-flex align-items-center">
                                        <MDBCol>
                                            <h5 className="float-left">About Me</h5>
                                        </MDBCol>
                                        <MDBCol>
                                            <Button className="float-right mx-1" onClick={()=>{toggleModal()}}>
                                                Change Password
                                            </Button>
                                            <Button className="float-right mx-1" onClick={()=>{toggleModal2()}} type="primary">
                                                Change Email
                                            </Button>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCardTitle>
                                <List
                                    itemLayout="horizontal"
                                >
                                    <List.Item>
                                        <b>Fullname :</b> {details&&details.firstname}  {details&&details.surname}
                                    </List.Item>
                                    <List.Item>
                                        <b>Email :</b> {details&&details.email}
                                    </List.Item>
                                    <List.Item>
                                        <b>Age :</b> {details&&moment().diff(details.dob, 'years')}
                                    </List.Item>
                                    <List.Item>
                                        <b>Phone Number :</b> {details&&details.phone}
                                    </List.Item>
                                    <List.Item>
                                        <b>Gender :</b> {details&&details.gender}
                                    </List.Item>
                                    <List.Item>
                                        <b>Department :</b> {details&&details.department}
                                    </List.Item>

                                </List>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBBox>



                </Content>
                <Dialog isShown={modal} hasFooter={false} title={"Change Account Password"} onCloseComplete={toggleModal}>
                    <ChangePassword modal={toggleModal}/>
                </Dialog>

                <Dialog isShown={modal2} hasFooter={false} title={"Change Account Email"} onCloseComplete={toggleModal2}>
                    <ChangeEmail modal={toggleModal2}/>
                </Dialog>

            </Layout>
        </Layout>
    )
}
export default  Settings;
